const getSuggestionTable = (state) => {
    return state.suggestion_table
}

export {
    getSuggestionTable,
};